const APPLICATION_CSV = 'application/csv';
const APPLICATION_JSON = 'application/json';

export type ErrorResponse = {
  message: string;
  status?: number;
  statusText?: string;
};

export type FetchDataResponse<T> = {
  data?: T;
  blob?: Blob;
  headers?: Headers;
  errorResponse?: ErrorResponse;
};

const httpErrorResponse = (response: Response) => ({
  errorResponse: {
    message: `HTTP error! status: ${response.status}`,
    status: response.status,
    statusText: response.statusText,
  },
});

const errorResponse = (error: Error | unknown) => ({
  errorResponse: {
    message: error instanceof Error ? error.message : 'An unexpected error occurred',
  },
});

export const fetchData = async <T>(
  url: string,
  headers: Headers
): Promise<FetchDataResponse<T>> => {
  try {
    const response = await fetch(url, {
      headers: headers,
    });
    if (!response.ok) {
      return httpErrorResponse(response);
    }
    const contentType = response.headers.get('Content-Type');
    if (contentType === APPLICATION_CSV) {
      return { blob: await response.blob(), headers: response.headers };
    } else if (contentType === APPLICATION_JSON) {
      return { data: await response.json() };
    }
    return errorResponse(
      new Error(
        `Invalid content type received from fetch: '${contentType}', must be either JSON or CSV`
      )
    );
  } catch (error) {
    return errorResponse(error);
  }
};
